// extracted by mini-css-extract-plugin
export var button = "countrySelector-module--button--3bbfb";
export var excerpt = "countrySelector-module--excerpt--74e40";
export var item = "countrySelector-module--item--488e6";
export var link = "countrySelector-module--link--009f4";
export var root = "countrySelector-module--root--ddb40";
export var title = "countrySelector-module--title--6ff8b";